import { addBreadcrumb, captureException, setUser, type SeverityLevel } from "@sentry/react-native";

import { crashlyticsLog, crashlyticsRecordError } from "../../modules/Crashlytics";

export function initSentryUser(memberId: string) {
  setUser({ id: memberId });
}

export function deInitSentryUser() {
  setUser(null);
}

export function logBreadcrumb(props: { message: string; category?: string; level?: SeverityLevel }) {
  addBreadcrumb({
    message: props.message,
    category: props.category,
    level: props.level,
  });

  crashlyticsLog(props.message);
}

export function logError(error: unknown) {
  captureException(error);

  const normalizedError = error instanceof Error ? error : new Error(String(error));
  crashlyticsRecordError(normalizedError);
}
